import { Flex } from '@chakra-ui/react';
import ComposeEmail from 'src/components/EmailModule';
import { Layout } from 'src/components/Layout';
import StepHeader from 'src/pages/Organization/public/Journal/SubmissionUpload/components/StepHeader';
import { IDomainCommandType } from '@publishing-engine/domain/actions/v1/commands';
import Loading from '../../../../pages/Status/Loading';
import { EmailTemplateDoc } from '@publishing-engine/domain/models/email-templates';
import { useState } from 'react';

interface Props {
  currentStep: number;
  emailTemplates: EmailTemplateDoc[] | undefined;
  totalSteps: number;
  footer?: React.ReactNode;
  adHocEmail?: boolean;
  removeBrowseTemplates?: boolean;
  emails?: string[];
  commandName: IDomainCommandType;
  attachments?: any[];
  isLoadingTemplates: boolean;
}

const ComposeReviewerInvitation = ({
  currentStep,
  totalSteps,
  footer,
  adHocEmail = false,
  removeBrowseTemplates = false,
  emails = [],
  emailTemplates,
  attachments = [],
  isLoadingTemplates
}: Props) => {
  if (isLoadingTemplates) return <Loading />;

  const [isEmailTemplatePopulated, setIsEmailTemplatePopulated] =
    useState(false);

  const composeEmailDescription = isEmailTemplatePopulated
    ? 'Compose your email, or select a template to pre-fill the subject and body. Submission details will be included automatically.'
    : 'Compose your email with a relevant subject and message for the recipient.';

  return (
    <>
      <Layout width="1200px" paddingY={2}>
        <Flex flexDirection="column" gap={2}>
          <StepHeader
            currentStep={currentStep}
            totalSteps={totalSteps}
            heading={adHocEmail ? 'Compose Email' : 'Compose Invitation'}
            description={
              adHocEmail
                ? composeEmailDescription
                : 'Use the default template to invite reviewers, or customize the invitation’s subject, personal, and journal information. Submission details are always included automatically.'
            }
            marginY={0}
          />

          <ComposeEmail
            emailTemplates={emailTemplates}
            adHocEmail={adHocEmail}
            removeBrowseTemplates={removeBrowseTemplates}
            emails={emails}
            attachments={attachments}
            setIsEmailTemplatePopulated={setIsEmailTemplatePopulated}
          />
        </Flex>
      </Layout>

      {footer && (
        <Flex
          paddingY={4}
          paddingX={6}
          bottom={0}
          zIndex={99}
          justifyContent="center"
          position="sticky"
          bgColor="surfacePrimaryFill"
          marginX="auto"
        >
          {footer}
        </Flex>
      )}
    </>
  );
};

export default ComposeReviewerInvitation;
